import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useLocationQuery } from '@/api/locations'
import IconTwoLineCell from '@/components/forms/cells/IconTwoLineCell.vue'

interface SubjectLocation {
  id: number
  parentId: number
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SubjectLocationCell',
  props: {
    subjectLocation: null
  },
  setup(__props: any) {

const props = __props as {
  subjectLocation: SubjectLocation
}



const { data: parentLocation } = useLocationQuery(
  props.subjectLocation.parentId
)

const hasShortName = computed(() => {
  return props.subjectLocation.name.length <= 3
})

const locationName = computed(() => {
  const locationName = props.subjectLocation?.name ?? ''
  if (hasShortName.value) {
    if (parentLocation.value?.location) {
      return `${parentLocation.value?.location} > ${locationName}`
    }
  }
  return locationName
})

const getLocationPath = computed(() => {
  return parentLocation.value?.location ?? ''
})

return { __sfc: true,props, parentLocation, hasShortName, locationName, getLocationPath, IconTwoLineCell }
}

})